import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Details from '../JobDetails/ApplicationDetails/Details'

function TrackedApplicationDetails() {
  const location = useLocation()
  console.log(location?.search?.split('='), 'leart5')
  return (
    <>
      <Details viewOnly={true} />
    </>
  )
}

export default TrackedApplicationDetails
